import { useState, type CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { apiPost, errOf } from '../lib/api';

const btn: CSSProperties = {
  padding: '4px 10px',
  borderRadius: 8,
  border: '1px solid var(--color-divider)',
  background: 'var(--color-card)',
  fontSize: 'var(--font-size-tiny)',
  cursor: 'pointer',
};
const btnPrimary: CSSProperties = { ...btn, background: 'var(--color-primary)', color: 'var(--color-on-primary)' };

/**
 * 「邀請」掣（admin 派邀請 → 會員設密碼 → 綁 `members.user_id`；decisions/002）
 * 成功 → 顯示**一次性**邀請連結（7 日有效）。連結含原 token → 只此一次顯示，DB 只存 hash。
 */
export default function InviteMemberButton({ memberId, email }: { memberId: string; email: string | null }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState('');
  const [err, setErr] = useState('');
  const [copied, setCopied] = useState(false);

  async function invite() {
    if (!email) {
      setErr(t('invite_need_email'));
      setUrl('');
      return;
    }
    setBusy(true);
    setErr('');
    setUrl('');
    setCopied(false);
    const r = await apiPost<{ inviteUrl?: string }>('/api/auth/invite', { email, role: 'member', memberId });
    setBusy(false);
    if (r.ok && r.data?.inviteUrl) setUrl(r.data.inviteUrl);
    else setErr(errOf(r.data) || t('invite_failed'));
  }

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <>
      <button type="button" style={btn} disabled={busy} onClick={() => void invite()}>
        {busy ? t('invite_working') : t('invite_member')}
      </button>
      {err && (
        <div className="text-xs mt-1" style={{ color: 'var(--color-danger)' }}>
          {err}
        </div>
      )}
      {url && (
        <div
          className="fixed left-1/2 z-50 rounded-xl p-3"
          style={{
            transform: 'translateX(-50%)',
            bottom: 16,
            width: 520,
            maxWidth: '92vw',
            background: 'var(--color-card)',
            boxShadow: 'var(--shadow-soft)',
            textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          <div className="flex items-center justify-between gap-2 mb-1">
            <strong className="text-sm">{t('invite_link_title')}</strong>
            <button type="button" style={btn} onClick={() => setUrl('')}>
              {t('btn_cancel')}
            </button>
          </div>
          <code className="block break-all text-xs mb-2" style={{ color: 'var(--color-text-secondary)' }}>
            {url}
          </code>
          <button type="button" style={btnPrimary} onClick={() => void copy()}>
            {copied ? t('invite_copied') : t('invite_copy')}
          </button>
          <p className="text-xs mt-2" style={{ color: 'var(--color-text-secondary)' }}>
            {t('invite_link_note')}
          </p>
        </div>
      )}
    </>
  );
}
